const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('../../assets/svgIcons', false, /\.svg$/)
requireAll(req)
